/** IMessageHelper Interface */
export interface IMessageHelper {
  /**
   * @param  {HTMLElement} element
   * @param  {string} text?
   * @param  {string} type?
   * @param  {number} timer?
   * @example Success: messageHelper.show(element, 'This is a message', 'success', 5000)
   * @example Error: messageHelper.show(element, 'This is a message')
   */
  show: (element: HTMLElement, text?: string, type?: string, timer?: number) => void
  /**
   * @param  {HTMLElement} element
   * @param  {boolean} clearText?
   * @param  {string} type?
   * @example reset(element, true, 'success')
   * @example reset(element, true)
   */
  reset: (element: HTMLElement, clearText?: boolean, type?: string) => void
}

/**
 * @description This is a helper used to show/hide messages. E.g. in forms.
 * @requires {string} a base class name of .message
 */
export const message: IMessageHelper = {
  show(element: HTMLElement, text = '', type = 'error', timer = 10000): void {
    element.style.display = 'block'

    if (text) {
      element.innerHTML = text
    }

    element.classList.add(`message--${type}`)

    if (timer > 0) {
      setTimeout(() => {
        this.reset(element)
      }, timer)
    }
  },

  reset(element: HTMLElement, clearText = false, type = 'error'): void {
    element.style.display = 'none'

    if (clearText) {
      element.innerHTML = ''
    }

    element.classList.remove(`message--${type}`)
  },
}
